import { render, staticRenderFns } from "./ConfirmBtn.vue?vue&type=template&id=6766bb4f&"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports